module.exports = __webpack_public_path__ + "static/media/ic-arrow-back.4dc669ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/ic-arrow-back.svg
// module id = 498
// module chunks = 0